import { useEffect, useState, useLayoutEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { fetchCourse } from "../../api/courses/teachers";
import { fetchLessons, updateLesson } from "../../api/lessons/teachers";
import { fetchLessonModules, updateLessonModules, deleteLessonModule } from "../../api/lesson_modules/teachers";

import BackButton from "../../components/Shared/BackButton";
import { BottomNav } from "./BottomNav";
import TeacherNavbar from "../../components/TeacherNavbar";
import TeacherSidebar from "../../components/Dashboard/TeacherSidebar";
import Saving from "../../components/Loading/Saving";

import { Input } from "../../components/Shared/Input";
import { Widgets } from '../../components/Widget';

import "./index.css";
import AddNewDropdown from "./AddNewDropdown";

function InitalWidget(props) {
  return (
    <div className="InitialWidget">
      <div className="InitialWidgetTab">
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <div className="InitialWidgetTabTag" />
          <div className="InitialWidgetTabHeader">
            Text/Image/Video/Question
          </div>
        </div>
        <div>
          <AddNewDropdown {...props} />
        </div>
      </div>
    </div>
  )
}

function TeacherLessonBuilder() {
  const [widgets, setWidgets] = useState([]);
  const [course, setCourse] = useState({});
  const [lesson, setLesson] = useState({});
  const [lessons, setLessons] = useState([]);
  const [lessonModules, setLessonModules] = useState([]);
  const [lessonTitle, setLessonTitle] = useState("");
  const [saving, setSaving] = useState(false);
  const [lessonModuleDelete, setLessonModuleDelete] = useState(false);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { lessonId } = useParams();
  useEffect(async () => {
    try {
      const res = await fetchLessonModules(lessonId);
      setLesson(res.lesson);
      setLessonTitle(res.lesson.title)
      if (res.lesson_modules.length > 0) {
        setWidgets(res.lesson_modules);
        setLessonModules(res.lesson_modules);
      } else {
        setWidgets([]);
        setLessonModules([]);
      }
    } catch (err) {
      console.log(err);
    }
  }, [pathname, lessonModuleDelete]);

  useEffect(async () => {
    if (!lesson.course_id) return;
    try {
      const res = await fetchLessons(lesson.course_id)
      setLessons(res);
    } catch (err) {
      console.log(err);
    }

    try {
      const res = await fetchCourse(lesson.course_id);
      setCourse(res);
    } catch (err) {
      console.log(err)
    }
  }, [lesson]);

  useEffect(() => document.body.style.backgroundColor = "#F5F5F5", []);
  useLayoutEffect(() => { return () => document.body.style.backgroundColor = null }, []);

  async function onUpdate() {
    try {
      setSaving(true);
      let _widgets = [...widgets];
      _widgets.sort((a, b) => a.position - b.position);
      const body = { lesson_modules: _widgets };
      const { lesson_modules }  = await updateLessonModules(lessonId, body);
      setWidgets(lesson_modules);
      setLessonModules(lesson_modules);

      const lessonBody = {
        ...lesson,
        title: lessonTitle
      }
      const lessonRes = await updateLesson(lessonId, lessonBody);
      setLesson(lessonRes);
    } catch (err) {
      console.log(err);
    } finally {
      setTimeout(() => {
        setSaving(false);
      }, 1000)
    }
  }

  async function onDelete(values) {
    if (values.id) {
      try {
        setSaving(true);
        const body = {
          id: values.lesson_id,  
          lesson_module: {
            id: values.id,
            lesson_module_name: values.lesson_module_name
          }
        };
        await deleteLessonModule(body)
        setLessonModules(lessonModules.filter(l => l.id !== values.id));
        setLessonModuleDelete(!lessonModuleDelete);
      } catch (err) {
        console.log(err);
      } finally {
        setTimeout(() => {
          setSaving(false);
        }, 1000)
      }
    }
  }

  function renderWidgets() {
    if (widgets.length > 0) {
      return (
        <Widgets
          course={course}
          widgets={widgets}
          setWidgets={setWidgets}
          collapseAll={()=> {}}
          onDelete={onDelete}
        />
      )
    }
    return (
      <InitalWidget 
        course={course}
        widgets={widgets}
        setWidgets={setWidgets}
      />
    )
  }

  const { title } = lesson;
  return (
    <>
      {saving && <Saving />}
      <TeacherSidebar />
      <TeacherNavbar />
      <div className="TeacherLessonBuilderContainer">
        <BackButton
          onClick={() => navigate(`/teacher/courses/${course.id}`)}
        />
      <div className="TeacherLessonBuilder">
        <div className="TeacherLessonBuilderSubNav">
          <div className="TeacherLessonBuilderSubNavHeader">
            <div className="HeaderTag" />
            <div className="HeaderText">{title}</div>
          </div>

          <div className="TeacherLessonBuilderSubNavItems">
            {lessons.map(({title, id}) => (
              <div className="TeacherLessonBuilderSubNavItemContainer">
                <div
                  className="TeacherLessonBuilderSubNavItem"
                  onClick={() => navigate(`/teacher/lessons/${id}/edit`)}
                >
                  <div
                    className="TeacherLessonBuilderSubNavItemText"
                  >{title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="TeacherLessonBuilderModules">
          <div className="TeacherLessonBuilderModule">
            <div className="TeacherLessonBuilderModuleHeader">
              <div className="HeaderTag" />
              <div className="HeaderText">Lesson Name</div>
            </div>
            <Input
              id='lessonTitle'
              type='text'
              name='Lesson title'
              className=''
              value={lessonTitle}
              onChange={(e) => {
                setLessonTitle(e.target.value);
              }}
            />
          </div>
          {renderWidgets()}
        </div>
      </div>
      </div>
      <BottomNav
        onSave={onUpdate}
        onPreview={async () => {
          // TODO: wrap try catch
          await onUpdate();
          navigate(`/lessons/${lessonId}/preview`)
        }}
      />
    </>
  )
}

export default TeacherLessonBuilder;
